import React from "react";
import { SubCategory } from "types/subCategory";
import AssistanceFields from "./Fields/Assistance/AssistanceFields";
import ChildCareFields from "./Fields/ChildCare/ChildCareFields";
import GardeningFields from "./Fields/Gardening/GardeningFields";
import HandiworkFields from "./Fields/Handiwork/HandiworkFields";
import HouseKeepingFields from "./Fields/HouseKeeping/HouseKeepingFields";
import TutoringFields from "./Fields/Tutoring/TutoringFields";

export interface RenderCategoryFieldsOptions {
    disabled?: boolean;
    /** When true, category-specific copy targets ads instead of provider services. */
    isAd?: boolean;
}

/**
 * Renders subcategory-specific form fields shared by service and ad forms.
 */
export function renderCategoryFields(
    subcategory: string | undefined,
    { disabled = false, isAd = false }: RenderCategoryFieldsOptions = {}
): React.ReactElement {
    switch (subcategory) {
        case SubCategory.TROUBLESHOOTING:
        case SubCategory.ADMINISTRATIVE:
        case SubCategory.INTERNET_USE:
            return <AssistanceFields disabled={disabled} />;
        case SubCategory.BABYSITTING_DURING_WEEK:
        case SubCategory.BABYSITTING_DURING_WEEKEND:
            return <ChildCareFields disabled={disabled} />;
        case SubCategory.PLANTATION:
        case SubCategory.TERRACE:
        case SubCategory.TRIMMING:
        case SubCategory.OUTDOOR_CLEANING:
            return <GardeningFields disabled={disabled} isAd={isAd} />;
        case SubCategory.SIMPLE:
        case SubCategory.SMALL_REPAIR:
        case SubCategory.INSTALLATION:
            return <HandiworkFields disabled={disabled} isAd={isAd} />;
        case SubCategory.CLEANING:
        case SubCategory.IRONING:
        case SubCategory.LAUNDRY:
            return <HouseKeepingFields disabled={disabled} isAd={isAd} />;
        case SubCategory.HOMEWORK:
        case SubCategory.FOREIGN_LANGUAGES:
        case SubCategory.OTHER_LESSON:
            return <TutoringFields disabled={disabled} />;
        default:
            return <></>;
    }
}
